import { useTranslation } from "react-i18next";
import { actionLogout } from "../../../api/postApi";
import { notice } from "../../../redux/action/action";
import { useDispatch } from "react-redux";
import UserLogout from "../../../api/UserLogout";
import {
  cleanMemberInfo,
  clearTransferWallet,
} from "../../../redux/action/member/memberAction";
import { clearFavoriteGameList } from "../../../redux/action/game/gameAction";
import { useNavigate } from "react-router-dom";
import { Box, Button, Text } from "@chakra-ui/react";
import { IoMdLogOut } from "react-icons/io";

const useLogoutButton = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleLogoutUser = () => {
    actionLogout().then((data) => {
      dispatch(
        notice({
          title: i18n("Logout Success"),
          type: "success",
        })
      );
      window?.google?.accounts?.id.disableAutoSelect();
      UserLogout();
      dispatch(cleanMemberInfo());
      dispatch(clearFavoriteGameList());
      dispatch(clearTransferWallet());
      navigate("/signin");
    });
  };

  return {
    asideLogoutBtn: (
      <Box
        onClick={handleLogoutUser}
        mt="10px"
        mx="20px"
        py="15px"
        px="12px"
        display="flex"
        alignItems={`center`}
        justifyContent={`center`}
        borderRadius={`full`}
        cursor={`pointer`}
        border={`1px solid`}
        borderColor="#4C74F5"
        bg="brand.500"
      >
        <Text as="span" color="white">
          {i18n("logout")}
        </Text>
      </Box>
    ),
    profileCardLogoutBtn: (
      <Button
        bg="brand.500"
        _hover={{
          bg: "brand.500",
        }}
        onClick={handleLogoutUser}
        color="white"
        fontSize="lg"
        aria-label="Logout"
        rightIcon={<IoMdLogOut />}
      >
        {i18n("logout")}
      </Button>
    ),
  };
};

export default useLogoutButton;
